import React, { useState, useEffect } from "react";
import { useTable, usePagination, useRowSelect } from "react-table";
import double_before from "../../../../assets/vw/svg/double-before.svg";
import before from "../../../../assets/vw/svg/before.svg";
import after from "../../../../assets/vw/svg/after.svg";
import double_after from "../../../../assets/vw/svg/double-after.svg";
import DropDown from "../../../../components/Dropdown";
import SEARCH from "../../../../assets/vw/svg/search.svg";
import delete_icon from "../../../../assets/vw/svg/eliminar.svg";
import menu_opc from "../../../../assets/vw/svg/menu-opciones.svg";
import success_icono from "../../../../assets/vw/svg/check-exito.svg";
import error_icono from "../../../../assets/vw/svg/check-error.svg";
import cerrar from "../../../../assets/vw/svg/cerrar.svg";
import Loading from "../../../../components/Loading";
import DropdownSearch from "../../../../components/DropdownSearch";
import copiar_icono from "../../../../assets/vw/svg/copiar.svg";
import InputText from "../../../../components/InputText";
import null_icono from "../../../../assets/vw/svg/null.svg";
import Cards from "../Cards";

/* Creación de un componente de casilla de verificación personalizado que puede ser indeterminado. */
const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;
    useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);
    return (
      <>
        <input
          type="checkbox"
          className="checkbox-round"
          ref={resolvedRef}
          {...rest}
        />
      </>
    );
  }
);

/* Creación de un objeto JavaScript con tres propiedades. */
const contextos = {
  VW: "eac42ad34c8f70c750fec028bcca658e27582f140dee8b0ec6b4a3ebafd946e9",
  AUDI: "b51026e4444f98ecdbe1d7cb1f310427a47d7a6e7659b37ce3d00010b09af252",
  SEAT: "5d2c13d6f9fa421125a9f55e56fd0e4df9319ef30087f8f4675cd6f05135f397",
};

const Table = ({
  columns,
  data,
  aplicaciones,
  servicio,
  marca,
  handleChange,
}) => {
  const [modal, setModal] = useState(false);
  const [cargando, setCargando] = useState(false);

  const [nombre, setNombre] = useState("");
  const [correo, setCorreo] = useState("");
  const [appId, setAppId] = useState("");
  const [jwtToken, setJwtToken] = useState("");
  const [refresh_token, setRefresh_token] = useState("");
  const [contexto, setContexto] = useState("");
  const [limit, setLimit] = useState(10);
  const limitMostrar = ["Mostrar 15", "Mostrar 30", "Mostrar 50", "Todo"];
  const [searchInput, setSearchInput] = useState("");
  const [row, setRow] = useState("");
  const [mostrarModal, setMostrarModal] = useState(false);
  const [mensajeArchivar, setMensajeArchivar] = useState(
    "¿Seguro que quieres eliminar este acceso?"
  );
  const [successArchivar, setSuccessArchivar] = useState(false);
  const [errorArchivar, setErrorArchivar] = useState(false);
  const [token, setToken] = useState("");
  const [modalToken, setModalToken] = useState(false);
  const [show, setShow] = useState(false);
  const [showGrid, setShowGrid] = useState(false);
  const [selectGrid, setSelectGrid] = useState([]);

  function searchText(e) {
    setSearchInput(e.target.value);
    handleChange(e);
  }

  const optionLimit = (textoLimit) => {
    switch (textoLimit) {
      case "Mostrar 15":
        return 15;
      case "Mostrar 30":
        return 30;
      case "Mostrar 50":
        return 50;
      case "Todo":
        return data.length;
      default:
        return data.length;
    }
  };

  /**
   * Cuando el usuario hace clic en el botón, el modal se establece en verdadero, el nombre, el correo
   * electrónico, appId, jwtToken, refresh_token y contexto se establecen en cadenas vacías, y appId se
   * establece en 0.
   */
  const nuevo = () => {
    setModal(true);
    setNombre("");
    setCorreo("");
    setAppId("0");
    setJwtToken("");
    setRefresh_token("");
    setContexto("");
  };

  /**
   * Establece el estado del modal en falso y establece el estado de las otras variables en cadenas
   * vacías.
   */
  const cancelar = () => {
    setModal(false);
    setNombre("");
    setCorreo("");
    setAppId("");
    setJwtToken("");
    setRefresh_token("");
    setContexto("0");
  };

  /**
   * Envía una solicitud POST a un servicio de backend y luego muestra un modal con la respuesta.
   */
  const envia = async () => {
    setCargando(true);
    setModal(false);
    const aplicacion = Number(appId);

    fetch(process.env.REACT_APP_URL_DTO_BACK + "sesiones/permanentes", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + servicio.getToken(),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        correo,
        contexto,
        jwtToken,
        appId: aplicacion,
        refresh_token,
        nombre,
      }),
    })
      .then(async (res) => {
        let responseBody = await res.json();
        if (!res.ok) {
          throw new Error(responseBody.mensaje);
        }
        setToken(responseBody.mensaje);
        setModalToken(true);
        setCargando(false);
      })
      .catch((errorP) => {
        setCargando(false);
        setMensajeArchivar("Hubo un error al guardar los cambios. " + errorP.message);
        setErrorArchivar(true);
        setMostrarModal(true);
      });
  };

  /**
   * Cuando el usuario cambie el valor del elemento de selección, establezca el valor de la variable de
   * estado appId en el valor del elemento de selección.
   * @param event - El objeto de evento es un evento de JavaScript que se envía a un elemento cuando
   * ocurre un evento en él.
   */
  const handleChangeAplicacion = (event) => {
    setAppId(event.props.value);
  };

  /**
   * Cuando el usuario cambia el valor de la entrada, establezca el valor del estado de contexto en el
   * valor de la entrada.
   * @param event - El objeto de evento es un evento de JavaScript que se envía a un elemento cuando
   * ocurre un evento en el elemento.
   */
  const handleChangeContexto = (event) => {
    setContexto(event.props.value);
  };

  /**
   * Es una función que elimina una fila de una tabla mandando una solicitud DELETE al backend
   */
  const eliminar = () => {
    setCargando(true);
    setMostrarModal(false);
    let arrayAcceso = [];
    if (row !== "") {
      arrayAcceso.push(row);
    } else if (selectedFlatRows.length > 0) {
      arrayAcceso = selectedFlatRows.map((row) => row.original);
    } else if (selectGrid.length > 0) {
      arrayAcceso = selectGrid;
    }
    for (let acceso of arrayAcceso) {
      const id = acceso.sesionId;
      fetch(process.env.REACT_APP_URL_DTO_BACK + "sesiones", {
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + servicio.getToken(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          idSesion: id,
        }),
      })
        .then(async (res) => {
          let responseBody = await res.json();
          if (!res.ok) {
            throw new Error(responseBody.mensaje);
          }
          console.log(responseBody.mensaje);
          setRow("");
          setCargando(false);
          setMensajeArchivar("Los cambios fueron guardados.");
          setSuccessArchivar(true);
          setMostrarModal(true);
        })
        .catch((errorP) => {
          setRow("");
          setCargando(false);
          setMensajeArchivar("Hubo un error al guardar los cambios.");
          setErrorArchivar(true);
          setMostrarModal(true);
        });
    }
  };

  function handleArchivar(e) {
    selectedFlatRows.length < 1 && selectGrid.length < 1
      ? setRow(e.row.original)
      : setRow("");
    setMostrarModal(true);
  }

  function clearModalArchivar() {
    if (successArchivar || errorArchivar) {
      // eslint-disable-next-line no-restricted-globals
      location.reload();
    } else {
      setRow("");
      setMostrarModal(false);
      setMensajeArchivar("¿Seguro que quieres eliminar este acceso?");
      setSuccessArchivar(false);
      setErrorArchivar(false);
    }
  }

  const buildPopUp = () => {
    return (
      <div
        className={`modal modal_vw modal_popup_vw fade ${mostrarModal ? "show" : ""}`}
        id="archivar"
        data-keyboard="false"
        data-backdrop="static"
        tabIndex="-1"
        aria-labelledby="archivarLabel"
        style={mostrarModal ? { display: "block" } : {}}
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal_popup_content">
          <div className="modal-content modal_content-vw">
            <div className="modal-header modal_header-vw">
              <div className="d-flex justify-content-end">
                <button
                  className="button_icon-vw"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={clearModalArchivar}
                >
                  <img src={cerrar} alt="cerrar"></img>
                </button>
              </div>
            </div>
            <div className={`modal-body p-3 p-sm-5 p-lg-5`}>
              {buildContent()}
              {successArchivar || errorArchivar ? "" : buildButtons()}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const buildContent = () => {
    return (
      <>
        {successArchivar ? (
          <div className="mt-0 mt-lg-2 px-2 mensaje_confirmacion mb-0 mb-sm-5">
            <div className="d-flex justify-content-center">
              <img
                src={success_icono}
                className="icono-mensaje"
                alt="exito"
              ></img>
            </div>
            <label className="popup_title popup_title--status d-flex justify-content-center">
              {mensajeArchivar}
            </label>
          </div>
        ) : errorArchivar ? (
          <div className="mt-0 mt-lg-2 px-2 mensaje_confirmacion mb-0 mb-sm-5">
            <div className="d-flex justify-content-center">
              <img
                src={error_icono}
                className="icono-mensaje"
                alt="error"
              ></img>
            </div>
            <label className="popup_title popup_title--status d-flex justify-content-center">
              {mensajeArchivar}
            </label>
          </div>
        ) : (
          <div className="mt-0 mt-lg-2 px-2 mensaje_confirmacion mb-0 mb-sm-5">
            <label className="popup_title d-flex justify-content-center">
              {mensajeArchivar}
            </label>
          </div>
        )}
      </>
    );
  };

  const buildButtons = () => {
    return (
      <div className="d-flex justify-content-center gap-3 mt-3 mt-sm-4 mt-lg-5 mb-3 mb-lg-5">
        <button
          type="button"
          className="button_vw button_vw--secondary"
          data-bs-dismiss="modal"
          onClick={clearModalArchivar}
        >
          Cancelar
        </button>
        <button
          type="button"
          className="button_vw button_vw--primary"
          data-bs-dismiss="modal"
          onClick={eliminar}
        >
          Eliminar
        </button>
      </div>
    );
  };

  const disabled_guardar = () => {
    if (appId === "0" || contexto === "") {
      return true;
    } else {
      return false;
    }
  };

  const buildPopUpRegistro = () => {
    return (
      modal && (
      <div
        className={`modal modal_vw fade ${modal ? "show" : ""}`}
        id="modal"
        data-keyboard="false"
        data-backdrop="static"
        tabIndex="-1"
        aria-labelledby="desarchivarLabel"
        style={modal ? { display: "block" } : {}}
        aria-modal="true"
        role="dialog"
      >
        <div
          className="modal-dialog modal-dialog-centered modal_lg_vw "
          role="document"
        >
          <div className="modal-content modal_content-vw p-0 p-lg-2">
            <div className="modal-header modal_header-vw ">
              <div className="d-flex justify-content-end">
                <button
                  className="button_icon-vw"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModal(false);
                  }}
                >
                  <img src={cerrar} alt="cerrar"></img>
                </button>
              </div>
            </div>
            <form onSubmit={envia}>
              <div className="modal-body mx-3 mx-sm-4 mx-lg-5 p-0 mb-2 mb-sm-4 mb-lg-0">
                <div className="d-flex justify-content-start titulo pb-2">
                  Nuevo Acceso Permanente
                </div>
                <div className=" border_vw"></div>
                <div className="row mt-3 p-0 mx-0 mt-4">
                  <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2 mt-2 mt-sm-0">
                    <InputText
                      inputLabel={"Nombre"}
                      inputField={nombre}
                      id={"nombre"}
                      changingInput={(event) => {
                        setNombre(event.target.value);
                      }}
                      required={true}
                    />
                  </div>
                  <div className="col-12 col-sm-6 px-0 pl-0 pl-sm-2 mt-2 mt-sm-0">
                    <InputText
                      inputLabel={"JwtToken"}
                      inputField={jwtToken}
                      id={"jwtToken"}
                      changingInput={(event) => {
                        setJwtToken(event.target.value);
                      }}
                    />
                  </div>
                </div>

                <div className="row p-0 mx-0 mt-2">
                  <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2">
                    <InputText
                      inputLabel={"Correo electrónico"}
                      inputField={correo}
                      id={"correo"}
                      changingInput={(event) => {
                        setCorreo(event.target.value);
                      }}
                      required={true}
                    />
                  </div>
                  <div className="col-12 col-sm-6 px-0 pl-0 pl-sm-2 mt-2 mt-sm-0">
                    <InputText
                      inputLabel={"Refresh Token"}
                      inputField={refresh_token}
                      id={"refreshToken"}
                      changingInput={(event) => {
                        setRefresh_token(event.target.value);
                      }}
                    />
                  </div>
                </div>

                <div className="row mt-2 mt-sm-3 p-0 mx-0">
                  <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2">
                    <DropdownSearch
                      menu={aplicaciones}
                      title={"Aplicación"}
                      defaultValue={appId}
                      handleOptionSelected={handleChangeAplicacion}
                      fieldID={'idApp'}
                      fieldToShow={'nombre'}
                    />
                  </div>
                  <div className="col-12 col-sm-6 px-0 pl-0 pl-sm-2 mt-4 mt-sm-0">
                    <DropdownSearch
                      menu={Object.entries(contextos).map((contexto, index) => (
                        {
                          id: contexto[1],
                          nombre: contexto[0]
                        }
                      ))}
                      title={"Contexto"}
                      defaultValue={contexto}
                      handleOptionSelected={handleChangeContexto}
                      fieldID={'id'}
                      fieldToShow={'nombre'}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer footer_modal_vw d-flex justify-content-center justify-content-lg-end gap-2 gap-sm-3 gap-lg-2 px-0 mx-3 mx-lg-5 mb-2 mb-sm-0 mt-lg-4">
                <button
                  type="button"
                  className="button_vw button_vw--secondary order-2 order-sm-1"
                  data-bs-dismiss="modal"
                  onClick={cancelar}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="button_vw button_vw--primary order-1 order-sm-2"
                  disabled={disabled_guardar()}
                  data-track-click="btn-guardar-acceso"
                >
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      )
    );
  };

  const clearToken = () => {
    setModalToken(false);
    setToken("");
    // eslint-disable-next-line no-restricted-globals
    location.reload();
  };

  const copiarToken = () => {
    navigator.clipboard.writeText(token);
    setShow(true);
    setTimeout(function () {
      setShow(false);
    }, 3000);
  };

  const buildPopUpToken = () => {
    return (
      <div
        className={`modal modal_vw fade ${modalToken ? "show" : ""}`}
        id="modal"
        data-keyboard="false"
        data-backdrop="static"
        tabIndex="-1"
        aria-labelledby="desarchivarLabel"
        style={modalToken ? { display: "block" } : {}}
        aria-modal="true"
        role="dialog"
      >
        <div
          className="modal-dialog modal-dialog-centered modal_lg_vw "
          role="document"
        >
          <div className="modal-content modal_content-vw p-2">
            <div className="modal-header modal_header-vw ">
              <div className="d-flex justify-content-end">
                <button
                  className="button_icon-vw"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={clearToken}
                >
                  <img src={cerrar} alt="cerrar"></img>
                </button>
              </div>
            </div>
            <div className="modal-body mx-5 p-0">
              <div className="d-flex justify-content-start titulo">Token</div>
              <div className=" border_vw"></div>
              <div className="d-flex justify-content-end mt-3">
                {show && <label className="label_text">Token copiado</label>}
                <button
                  className="button_icon-vw"
                  type="button"
                  onClick={copiarToken}
                >
                  {" "}
                  <img
                    src={copiar_icono}
                    alt="archivar"
                    className="px-2"
                  ></img>{" "}
                </button>{" "}
              </div>

              <div className="row mt-3 p-0 mx-0">
                <textarea
                  type="text"
                  className={"input_vw"}
                  id="token"
                  value={token}
                  rows="8"
                />
              </div>
            </div>
            <div className="modal-footer footer_modal_vw d-flex justify-content-center">
              <button
                type="button"
                className="button_vw button_vw--primary"
                data-bs-dismiss="modal"
                onClick={clearToken}
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  function localDateTimeToUTC(date) {
    const fechaLocal = new Date(date);

    // Fecha UTC en formato compatible con MYSQL: YYYY-MM-DD HH:MM:SS
    const fechaUTC = fechaLocal.toISOString().slice(0, 19).replace("T", " ");

    return fechaUTC;
  }

  const onChangeGrid = (value) => {
    setShowGrid(value);
    setSelectGrid([]);
    toggleAllRowsSelected(false);
  };

  const selects = (canal, tipo) => {
    if (tipo === "push") {
      setSelectGrid([...selectGrid, canal]);
    } else if (tipo === "pop") {
      let idCanal = canal.idCanal;
      setSelectGrid((l) => l.filter((item) => item.idCanal !== idCanal));
    }
  };

  const gridAccesos = (page) => {
    const selectCheck = (e, index) => {
      let y = document.getElementById(e.target.id);
      let canal = page[index].original;
      if (y.checked) {
        selects(canal, "push");
      } else {
        selects(canal, "pop");
      }
    };

    const getApp = (idApp) => {
      if (idApp) {
        const objApp = aplicaciones.find((app) => app.idApp === idApp);
        return objApp.nombre;
      } else return "-";
    };

    return (
      <div className="grid__view row">
        {page.map((acceso, index) => {
          let contexto = Object.entries(contextos).find((ctx) => ctx[1] === acceso.original.contexto);

          return (
            <div className="col-3 mb-3" key={index}>
              <div className="card_grid">
                <div className="d-flex">
                  <div className="container_id px-2">
                    {acceso.original.sesionId}
                  </div>
                  <div key={"select-" + index} className="ms-auto">
                    <input
                      key={"select-" + index}
                      type="checkbox"
                      className="checkbox-round mx-1"
                      id={"select-" + index}
                      value={acceso.original.sesionId}
                      onChange={(e) => selectCheck(e, index)}
                    />
                  </div>
                </div>

                <div className="d-flex align-items-start flex-column mx-3 mt-2 size-card">
                  <div className="contenedor_height w-100 mb-1">
                    <div className="title_card">
                    {acceso.original.correo.length > 40
                        ? `${acceso.original.correo.substring(0, 37)}…`
                        : acceso.original.correo}</div>
                    <div className="url_description mb-auto py-2">
                    {acceso.original.nombre.length > 23 ?`${acceso.original.nombre.substring(0, 20)}…` : acceso.original.nombre}

                    </div>
                    <div className="url_description">
                    {contexto ? contexto[0] : ""}{" "}{localDateTimeToUTC(acceso.original.fechaInicio)}
                    </div>
                  </div>
                  <div className="mt-2">
                    <span className="url_description me-1">
                    {getApp(acceso.original.appId).length > 23 ?`${getApp(acceso.original.appId).substring(0, 20)}…` : getApp(acceso.original.appId)}
                    </span>
                    <div className={` tooltip_vw`}>
                      <img src={menu_opc} alt="menu"></img>
                      <div className="tooltiptext p-2 ">
                        <button
                          className="button_icon-vw"
                          type="button"
                          onClick={() => handleArchivar({ row: acceso })}
                        >
                          <div className="aling-icon-eliminar">
                            {" "}
                            <img
                              src={delete_icon}
                              alt="archivar"
                              className="px-2"
                            ></img>{" "}
                            Eliminar
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  /* Usar el gancho useTable para crear una tabla. */
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    selectedFlatRows,
    state: { pageIndex },
    toggleAllRowsSelected,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 15 },
    },
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: "selection",
          Header: ({ getToggleAllPageRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllPageRowsSelectedProps()} />
            </div>
          ),
          Cell: ({ row }) => (
            <div>
              <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );

  const NavigationControl = () => {
    return (
        <div className="btn-group btn-group-controls" role="group" aria-label="First group">
          <button
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={double_before} alt="first"/>
          </button>
          {" "}
          <button
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={before} alt="before"/>
          </button>
          {" "}
          <div className="num_pagination py-3">
            {pageIndex + 1} de {pageOptions.length}
          </div>
          <button
              onClick={() => nextPage()}
              disabled={!canNextPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={after} alt="after"/>
          </button>
          {" "}
          <button
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={double_after} alt="last"/>
          </button>
          {" "}
        </div>
    );
  }

  return cargando ? (
      <Loading/>
  ) : (
      <>
        <div className="content main-content-container">
          <div className="main-content-actions row m-0 py-2">
            <div className="col-7 col-sm-6 col-lg-3 wrapper m-0 p-0 ">
              <input
                  className="input_vw"
                  name="searchInput"
                  value={searchInput || ""}
                  onChange={(e) => {
                    searchText(e);
                  }}
                  placeholder="Busca por ID, nombre, número…."
              />
              <span className="pt-2 ps-1">
              <img src={SEARCH} alt="buscar" className="icono-menu me-3"/>
            </span>
            </div>

            <div className="d-flex col-1 col-sm-1 col-lg-3">
              <button
                  type="button"
                  onClick={nuevo}
                  className={"button_vw button_vw--primary button_new_item " + (!!(selectedFlatRows.length > 0 || selectGrid.length > 0) ? "is_not_enabled" : "enabled")}
                  disabled={!!(selectedFlatRows.length > 0 || selectGrid.length > 0)}
                  data-track-click="btn-nuevo-acceso"
              >
                <div className={"add-icon"}></div>
                <span className={"ml-2"}>Nuevo</span>
              </button>

              {selectedFlatRows.length > 0 || selectGrid.length > 0 ? (
                  <button
                      type="button"
                      className={"button_vw button_vw--eliminar button_delete_item"}
                      onClick={handleArchivar}
                  >
                    <div className={"delete-icon"}></div>
                    <span className={"ml-2"}>Eliminar</span>
                  </button>
              ) : (
                  ""
              )}
            </div>

            <div className="col-3 col-sm-5 col-lg-6 p-0">
              <div className="d-flex justify-content-end align-items-center">
                <div className={`view_select_all ${showGrid ? 'icon_grid_active' : ''} ms-auto align-self-center`}>
                  <input
                      type="checkbox"
                      className="checkbox-round mx-1"
                      id={"1"}
                      value={0}
                      onChange={() => {
                      }}
                  />
                </div>
                <div className="view__options">
                  <button
                      className="button_icon-vw kit_icon"
                      type="button"
                      onClick={() => onChangeGrid(true)}
                  >
                  <span
                      className={`${showGrid ? "icon-grid-active" : "icon-grid"}`}
                  >
                    {" "}
                  </span>
                  </button>
                  <button
                      className="button_icon-vw kit_icon"
                      type="button"
                      onClick={() => onChangeGrid(false)}
                  >
                  <span
                      className={`${
                          !showGrid ? "icon-table-active" : "icon-table"
                      }`}
                  >
                    {" "}
                  </span>
                  </button>
                </div>
                <div className="">
                  <DropDown
                      menu={limitMostrar}
                      title={limitMostrar[0]}
                      inputField={limit}
                      handleOptionSelected={(e) => {
                        const limitInt = optionLimit(e);
                        setLimit(limitInt);
                        setPageSize(Number(limitInt));
                      }}
                  />
                </div>
                <NavigationControl/>
              </div>
            </div>
          </div>
        </div>

        <Cards
            page={page}
            handleArchivar={handleArchivar}
            selects={selects}
            NavigationControl={NavigationControl}
            aplicaciones={aplicaciones}
            contextos={contextos}
        />

        {showGrid ? (
            gridAccesos(page)
        ) : (
          <div 
          className="table-responsive"
          style={{
            overflowY: 'hidden'
          }}
        >
            <table
                {...getTableProps()}
          className="table table-striped table-responsive tabla_contenido_vw"
        >
          <thead className="thead-dark">
            {headerGroups.map((headerGroup) => (
              <tr
                {...headerGroup.getHeaderGroupProps()}
                className="thead__titulo"
              >
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()} className="tbody-table">
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell, cellId) => {
                    if (cell.column.id !== "selection" && (cell.value === undefined || cell.value === "") ) {
                      return (
                        <td key={cellId}><img src={null_icono} alt="sinsoporte"></img></td>
                      );
                    }
                    if (cell.column.Header === "Fecha Inicio") {
                      return (
                        <td
                          className="contenido_boolean"
                          {...cell.getCellProps()}
                        >
                          <div className={`d-flex justify-content-between`}>
                            {localDateTimeToUTC(cell.value)}
                            <div className={` tooltip_vw`}>
                              <img src={menu_opc} alt="menu"></img>
                              <div className="tooltiptext p-2 ">
                                <button
                                  className="button_icon-vw"
                                  type="button"
                                  onClick={() => handleArchivar(cell)}
                                >
                                  <div className="aling-icon-eliminar">
                                    {" "}
                                    <img
                                      src={delete_icon}
                                      alt="archivar"
                                      className="px-2"
                                    ></img>{" "}
                                    Eliminar
                                  </div>
                                </button>
                              </div>
                            </div>
                          </div>
                        </td>
                      );
                    }
                    return (
                      <td
                        className="contenido_boolean"
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}{" "}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
          </div>
      )}
      {buildPopUp()}
      {buildPopUpRegistro()}
      {buildPopUpToken()}
    </>
  );
};

const Tabla = (props) => {
  /* Creación de una tabla con las siguientes columnas: ID, Correo, Nombre, Aplicacion, Fecha Inicio. */
  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "sesionId",
      },
      {
        Header: "Correo",
        accessor: "correo",
      },
      {
        Header: "Nombre",
        accessor: "nombre",
      },
      {
        Header: "Contexto",
        accessor: "contexto",
        Cell: (p) => {
          let contexto = Object.entries(contextos).find((ctx) => ctx[1] === p.value);
          return (
            <div>
              {" "}
              {
                contexto ? contexto[0] : "-"
              }{" "}
            </div>
          );
        },
      },
      {
        Header: "Aplicacion",
        accessor: "appId",
        Cell: (p) => (
          <div>
            {" "}
            {
              props.aplicaciones.filter((x) => x.idApp === parseInt(p.value))[0]
                ?.nombre
            }{" "}
          </div>
        ),
      },
      {
        Header: "Fecha Inicio",
        accessor: "fechaInicio",
        Cell: (p) => (
          <div>
            {" "}
            {new Date(p.value).toLocaleString("es-MX", {
              year: "numeric",
              month: "numeric",
              day: "numeric",
            })}{" "}
          </div>
        ),
      },
    ],
    [props.aplicaciones]
  );
  return (
    <>
      <Table
        columns={columns}
        data={props.accesosPermanentes}
        aplicaciones={props.aplicaciones}
        servicio={props.servicio}
        marca={props.marca}
        handleChange={props.handleChange}
      />
    </>
  );
};

export default Tabla;
